import React from 'react';
import { RecordContextProvider, useListContext } from 'react-admin';
import Grid from '@mui/material/Grid';

import WeeklyCard from '../WeeklyCard';

const WeeklyGrid = () => {
    const { data } = useListContext();

    return (
        <Grid container spacing={2} sx={{ mt: 0 }}>
            {data?.map(record => (
                <RecordContextProvider key={record.id} value={record}>
                    <Grid key={record.id} size={{ sm: 12, md: 6, lg: 6, xl: 6 }}>
                        <WeeklyCard record={record} key={`weekly_${record?.id}`} />
                    </Grid>
                </RecordContextProvider>
            ))}
        </Grid>
    );
};

export default WeeklyGrid;